import { IconImageInPicture, IconPrinter, IconTruckDelivery } from '@tabler/icons-react'
import { ReactNode } from 'react'
import { useShopBrand } from '@/contexts/shopBrandContext.tsx'

export default function OurOffer() {
  const brand = useShopBrand()
  function Offer({ icon, title, description }: { icon: ReactNode, title: string, description: string }) {
    return <div className='flex flex-col gap-5 justify-center items-center text-center'>
      { icon }
      <h2 className='text-xl font-medium'>{title}</h2>
      <p>{ description}</p>
    </div>
  }

  return <section>
    <div className="container mx-auto px-4 flex flex-col items-center pt-[2rem] pb-[4rem] text-center gap-4 mt-[2rem]">
      <h2 className="text-3xl mb-[2rem] font-serif">
        Fotoprodukte - Unkompliziert und direkt integriert
      </h2>

      <div className='flex flex-row gap-3 justify-between'>
        <Offer icon={<IconImageInPicture size={56} />} title='Einfach gestalten' description={`Alle deine Bilder in ${brand.name} sind sofort verfügbar - kein lästiges Uploaden nötig!`} />
        <Offer icon={<IconPrinter size={56} />} title='Vielfältige Fotopordukte' description='Wähle einfach aus unserer Auswahl an Fotoprodukten aus.' />
        <Offer icon={<IconTruckDelivery size={56} />} title='Schnelle Lieferung' description='Wir produzieren in Deutschland und liefern nach Deutschland und Österreich.' />
      </div>

    </div>
  </section>
}
